<template>
    <h5
        class="c-title-text"
        :class="{
            'is-dark': type == 'dark',
        }"
    >
        <span>
            <slot name="left"></slot>
        </span>
        <span class="text-import">
            <slot name="import"></slot>
        </span>
        <span>
            <slot name="right"></slot>
        </span>
    </h5>
</template>

<script>
export default {
    name: "TitleText",
    props: {
        type: { type: String },
    },
};
</script>

<style scoped lang="less">
.c-title-text {
    font-size: 42px;
    color: #222;
    position: relative;
    z-index: 22;
    font-weight: normal;
    &.is-dark {
        color: #fff;
        .text-import {
            color: #4e67ff;
        }
    }
    .text-import {
        color: #4e67ff;
    }
}
@media only screen and (max-width: 1200px) {
    .c-title-text {
        font-size: 32px;
    }
}
@media only screen and (max-width: 768px) {
    .c-title-text {
        font-size: 26px;
    }
}
</style>
